<template>
  <section class="vbox">
    <section class="scrollable wrapper">
      <div class="content-header">      
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item><a href="/">系统</a></el-breadcrumb-item>
          <el-breadcrumb-item>日志监控</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="content-main">
        <el-form :inline="true" size="medium">    
          <el-form-item >
            <el-input  placeholder="内容" v-model="queryParam.content" size="small" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" v-on:click="Search" size="small" >查询</el-button>
          </el-form-item>
        </el-form>
        <el-table :data="rows" style="width: 100%">
          <el-table-column prop="Content"  label="内容" > </el-table-column>
          <el-table-column prop="Account"  label="操作员" > </el-table-column>
          <el-table-column prop="IpAddress"  label="IP" > </el-table-column>
          <el-table-column prop="OperateTime"  label="操作时间" > </el-table-column>        
        </el-table>
        <el-pagination
          :hide-on-single-page="false"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryParam.pageIndex"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="queryParam.pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="queryParam.totalCount">
        </el-pagination>
      </div>
    </section>
  </section>
</template>
<script  type='text/ecmascript-6'>
import Security from '../../../components/Security.vue';
  export default {
    data (){
      return {
        rows:[],
        queryParam:{
          content:'',
          pageIndex:1,
          pagesize:10,
          totalCount:0,
          sort:'Id desc',
        }
      }
    },
    components:{
        Security
    },
    computed:{
    },
    mounted(){
      this.GetData();
    },
    methods:{     
      Search:function(){
        this.queryParam.pageIndex = 1;
        this.GetData();
      },
      GetData:function(){
        var that = this
        this.axios({
          method:'get',
          url:that.global.serverSrc + '/api/System/Log',
          params: this.queryParam
        }).then(function (resp) {
          that.queryParam.totalCount = resp.data.totalCount
          that.rows = resp.data.data
        }).catch(resp => {
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      },
      handleSizeChange(val) {
        this.queryParam.pagesize = val 
        this.queryParam.pageIndex = 1
        this.GetData()
      },
      handleCurrentChange(val) {
        this.queryParam.pageIndex = val 
        this.GetData()
      }
    },
    created(){
    
    },
  }
</script>
<style lang='stylus' rel='stylesheet/stylus'>
.content-header
  padding 24px
  border 1px solid #C0C4CC
.content-main
  padding 24px  
.map
  width: 100%;
  height: 200px;
</style>